// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getAuth, signInAnonymously } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCbbmpGqw9mSDHzJGI1MDSfjh1IoHewrV8",
  authDomain: "magicmoon-tattoo.firebaseapp.com",
  databaseURL: "https://magicmoon-tattoo-default-rtdb.firebaseio.com",
  projectId: "magicmoon-tattoo",
  storageBucket: "magicmoon-tattoo.firebasestorage.app",
  messagingSenderId: "847025478991",
  appId: "1:847025478991:web:b24e578062711bf345f93a",
  measurementId: "G-9HCP3CCFPZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
let analytics;
try {
  // Analytics pode falhar em alguns ambientes, então envolvemos em try/catch
  analytics = getAnalytics(app);
} catch (error) {
  console.warn("Analytics não inicializado:", error);
}
const database = getDatabase(app);
const auth = getAuth(app);

// Função para autenticar anonimamente
export const anonymousSignIn = async () => {
  try {
    await signInAnonymously(auth);
    return true;
  } catch (error) {
    console.error("Erro na autenticação anônima:", error);
    return false;
  }
};

// Realizar autenticação anônima automaticamente
anonymousSignIn().then(success => {
  if (success) {
    console.log("Autenticação anônima realizada com sucesso");
  }
});

export { app, analytics, database, auth }; 